import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { HttpClient } from '@angular/common/http';
import { ApiUrlConstants } from 'src/app/common/constants/api.constants';
import { catchError } from 'rxjs/internal/operators';
import { Observable } from 'rxjs/Observable';
import { StorePortal } from '../interfaces/store-config.interface';
import { StorePortalFeature } from '../interfaces/privilege.interface';

@Injectable({ providedIn: 'root' })
export class StorePortalFeatureService {

    constructor(private httpClient: HttpClient,
        private _cacheService: CacheService) { }

    /**
   * To get Store portal features by store Id and portal id
   * @returns Observable
   */
    getStorePortalFeatures(storeId: number, portalId: number): Promise<StorePortalFeature[]> {
        const getStorePortals = ApiUrlConstants.configurationApiUrl + 'stores/' +
            storeId + '/portals/' + portalId + '/features';
        return this.httpClient
            .get<StorePortalFeature[]>(decodeURIComponent(encodeURIComponent(getStorePortals)))
            .pipe(catchError(this.handleErrorObservable)).toPromise();
    }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }
}